module.exports = __webpack_public_path__ + "static/media/squiggle1.b83aca52.png";